import React from 'react';
import styles from './styles.module.scss';
import { useTranslation } from 'next-i18next';
import BaseText from 'src/shared/components/BaseText';
import RoundedButton from 'src/shared/components/RoundedButton';
import TitleText from 'src/shared/components/TitleText';

import Card from '../Card';
import useCompanyInfo from 'src/hooks/useCompanyInfo';
import GaService from 'src/services/GaService';
import GaCategory from 'src/config/GaCategory';
import GaAction from 'src/config/GaAction';

interface Props {
    className?: string;
}

const WHATSAPP_ICON_CLASS = 'icon-btn_footer_whatsapp';
const PHONE_ICON_CLASS = 'icon-phone';

const SupportCenterCard = (props: Props) => {
    const { t } = useTranslation();

    const {
        phone,
        socialMedia: { whatsApp },
    } = useCompanyInfo();

    const [, phoneWithoutCountryCode] = phone.hk.match(/[^\s]+ (.*)/);

    const triggerGa = (action) => {
        GaService.callEvent(GaCategory.marketing, action, 'support center');
    };

    const onWhatsAppButtonClick = () => triggerGa(GaAction.clickWhatsApp);

    const onPhoneButtonClick = () => triggerGa(GaAction.clickPhone);

    return (
        <Card className={`SupportCenterCard ${styles.container} ${props.className}`}>
            <div className={styles.header}>
                <TitleText tag="h6" className={styles.title}>
                    {t('support_center_card_title')}
                </TitleText>
                <BaseText className={styles.description}>{t('support_center_card_description')}</BaseText>
            </div>
            <div className={styles.buttons}>
                <RoundedButton
                    type="primary-on-light"
                    className={`${styles.button} ${styles.whatsapp}`}
                    href={whatsApp.href}
                    onClick={onWhatsAppButtonClick}
                    isExternalLink
                >
                    <i className={`${styles.whatsappIcon} ${WHATSAPP_ICON_CLASS}`} />
                    {t('support_center_card_whatsapp_button')}
                </RoundedButton>
                <RoundedButton
                    type="secondary-on-light"
                    className={`${styles.button} ${styles.phone}`}
                    href={`tel:${phone.hk}`}
                    onClick={onPhoneButtonClick}
                >
                    <i className={`${styles.phoneIcon} ${PHONE_ICON_CLASS}`} />
                    {`${t('support_center_card_hotline_button')} ${phoneWithoutCountryCode}`}
                </RoundedButton>
            </div>
        </Card>
    );
};

SupportCenterCard.defaultProps = {
    className: '',
};

export default SupportCenterCard;
